
export class DTOParcelRoute {
    ParcelID: number;
    RouteID: number;
    NoStop: number;
    AddToExisting: boolean;
    UserID: number;
  }
  